module.exports = __webpack_public_path__ + "img/img06.ed4dd044.png";